import React, { useEffect, useCallback } from 'react';
import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import Layout from 'components/Layout';
import { ability } from 'config/ability';
import styles from './BrokerList.styled';
import { useHistory } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import { Tab, Tabs, TabPanel } from 'components/UI';
import { useDispatch, useSelector } from 'react-redux';
import { OrganizationsActions } from 'state/modules/organizations';
import { OrganizationBrokersWidget } from 'components/Organization';
import { Box, Grid, Paper, Container, Typography } from '@mui/material';

const BrokerList = () => {
  const theme = useTheme();
  const history = useHistory();
  const privileges = useSelector((state) => state?.user?.permissions || {});
  const hasPermission = ability.can('update', 'organization_brokers');
  const { organization, availablesBrokers, fetchedDeleteOrganizationsToBrokers } = useSelector(
    (state) => state.organizations
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(privileges).length > 0 && !hasPermission) {
      history.push(buildUrl('/404'));
    }
  }, [hasPermission, privileges, history]);

  const fetchOrgToBrokers = useCallback(() => {
    if (
      fetchedDeleteOrganizationsToBrokers !== 'LOADING' &&
      Object.keys(privileges).length > 0 &&
      hasPermission
    ) {
      dispatch(OrganizationsActions.fetchAvailablesBrokers({ connected: false }));
    }
  }, [fetchedDeleteOrganizationsToBrokers, privileges, hasPermission, dispatch]);

  useEffect(() => {
    fetchOrgToBrokers();
  }, [fetchOrgToBrokers]);

  return (
    <Layout title={i18n.t('organization_brokers.title')}>
      <Container sx={styles.container}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              <Box sx={{ fontWeight: 'bold', fontSize: 24, mt: 2, mb: 3 }}>
                {i18n.t('organization_brokers.title')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3} sx={styles.paper}>
              <Tabs value={0} aria-label="tab">
                <Tab sx={styles.tab} label={i18n.t('organization_brokers.tab_title')} />
              </Tabs>
              <Box sx={styles.tabContent}>
                <SwipeableViews index={0}>
                  <TabPanel value={0} index={0} dir={theme.direction}>
                    <Box
                      sx={{
                        justifyContent: 'left',
                        alignItems: 'left',
                        textAlign: 'justify',
                        flexDirection: 'column',
                        display: 'flex',
                        mb: 4,
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: 16,
                          component: 'h5',
                          lineHeight: 1,
                          fontWeight: 'bold',
                          mb: 2,
                        }}
                      >
                        {i18n.t('organization_brokers.broker_provider')}
                      </Box>
                      <Typography color="textPrimary" sx={styles.description}>
                        <Box component="span" sx={{ fontSize: 14, lineHeight: 1 }}>
                          {i18n.t('organization_brokers.broker_provider_description')}
                        </Box>
                      </Typography>
                    </Box>
                    <OrganizationBrokersWidget
                      loading={fetchedDeleteOrganizationsToBrokers === 'LOADING'}
                      organization={organization}
                      brokers={availablesBrokers}
                      refreshBrokers={fetchOrgToBrokers}
                    />
                  </TabPanel>
                </SwipeableViews>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export { BrokerList };
